import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
/**
 * List of the object types that have the "Performance" tab.
 */
export const PERFORMANCE_ALLOW_LIST = [OBJECT_TYPE.BLOG_POST, OBJECT_TYPE.CONTENT, OBJECT_TYPE.CTA, OBJECT_TYPE.FORM, OBJECT_TYPE.LANDING_PAGE, OBJECT_TYPE.MARKETING_EMAIL, OBJECT_TYPE.MARKETING_SMS, OBJECT_TYPE.SITE_PAGE, OBJECT_TYPE.SOCIAL_BROADCAST, OBJECT_TYPE.WORKFLOW, OBJECT_TYPE.WEB_INTERACTIVE, OBJECT_TYPE.WHATSAPP];
export const hasMetrics = data => {
  return data.some(group => {
    return group.stats.length > 0;
  });
};